interface TextInputProps {
  value: string | null | undefined
  placeholder?: string
  type?: "text" | "email"
  className?: string
  onChange: (value: string | null) => void
}

export default function TextInput({
  value,
  placeholder,
  type = "text",
  className,
  onChange,
}: TextInputProps) {
  const inputClassName = className ?? "box-form-input form-control"

  return (
    <input
      className={inputClassName}
      type={type}
      placeholder={placeholder}
      value={value ?? ""}
      onChange={(event) => {
        const rawValue = event.currentTarget.value
        onChange(rawValue === "" ? null : rawValue)
      }}
    />
  )
}